import {
  chainsFromEnv,
  enabledChainsFromEnv,
  findChainById as findById,
  findChainByShortName as findByShortName,
  type ChainConfig,
} from "@atelier/config";
import { defineChain, type Chain } from "viem";

const env = import.meta.env as unknown as Record<string, string | undefined>;

const cached = chainsFromEnv(env, "VITE_");
const enabledCached = enabledChainsFromEnv(env, "VITE_");

export function allChains(): ChainConfig[] {
  return cached;
}

export function enabledChains(): ChainConfig[] {
  return enabledCached;
}

export function byId(chainId: number): ChainConfig | undefined {
  return findById(cached, chainId);
}

export function byShortName(shortName: string): ChainConfig | undefined {
  return findByShortName(cached, shortName);
}

/** Convert a ChainConfig into a viem Chain object usable by wagmi. */
export function toViemChain(cfg: ChainConfig): Chain {
  return defineChain({
    id: cfg.chainId,
    name: cfg.name,
    nativeCurrency: cfg.nativeCurrency,
    rpcUrls: {
      default: { http: [cfg.rpcUrl] },
      public: { http: [cfg.rpcUrl] },
    },
    blockExplorers: cfg.explorerUrl
      ? { default: { name: "Explorer", url: cfg.explorerUrl } }
      : undefined,
  });
}
